import { RecSizeDisk } from '../../entities/Auto/module/types/autoSelectsTypes';
import { compare } from '../../shared/helpers/compare/';

export const sortSizeDisks = (a: RecSizeDisk, b: RecSizeDisk) => {
  const diameterComparison = compare(Number(a.diameter), Number(b.diameter));
  if (diameterComparison !== 0) {
    return diameterComparison;
  }

  const widthComparison = compare(Number(a.width), Number(b.width));
  if (widthComparison !== 0) {
    return widthComparison;
  }

  return compare(Number(b.et), Number(a.et));
};
